export interface CompanyDetailsDTO {
  companyId?: number;
  id?: number;
  additionalInfo?: CompanyAdditionalInfo;
  companyAccountManagers?: CompanyAccountManagers;
  companyContacts?: CompanyContacts;
  companyOffices?: CompanyOffice[];
  mainInfo?: CompanyMainInfo;
}

export interface CompanyMainInfo {
  bulstat?: string;
  externalId?: string;
  id?: number;
  name?: string;
  vat?: string;
  owners?: CompanyOwner[];
  companyAddresses?: CompanyAddress[];
}

export interface CompanyOwner {
  firstName: string;
  lastName: string;
  middleName: string;
  position: string;
}

export interface CompanyAdditionalInfo {
  totalNumberOfWorkers?: number;
  economicClassificator?: string;
  economicClassificatorName?: string;
  additionalInformation?: string;
  freeQuotasDissabilites?: number;
  parentCategory?: CompanyCategory;
  categories?: CompanyCategory[];
  selectedCategory?: CompanyCategory;
}

export interface CompanyOffice {
  id?: number;
  contactPerson?: CompanyWorker;
  workerId?: number;
  name?: string;
  phone?: string;
  medikoAgent?: string;
  serviceWorker?: string;
  addresses?: CompanyAddress[];
  note?: string;
  parentCompanyId?: number;
  email?: string;
}

export class CompanyPhysicalOffice  {
  id: number;
  contactPerson?: CompanyWorker;
  workerId: number;
  name?: string;
  phone?: string;
  medikoAgent?: string;
  serviceWorker?: string;
  addresses?: CompanyAddress[];
  note?: string;
  parentCompanyId?: number;
  email?: string;

  constructor(dto: CompanyOffice) {
    this.id = 0;
    this.workerId = 0;
    if (dto.id)
      this.id = dto.id;
    if (dto.workerId)
      this.workerId = dto.workerId;
    if (Array.isArray(dto.addresses)) {
      var item = dto.addresses as unknown as CompanyAddress[];
      this.addresses = item;
    }
    else {
      var singleItem = dto.addresses as unknown as CompanyAddress;
      this.addresses = [singleItem];
    }


    
    this.contactPerson = dto.contactPerson;
    this.name = dto.name;
    this.phone = dto.phone;
    this.medikoAgent = dto.medikoAgent;
    this.serviceWorker = dto.serviceWorker;
 
    this.note = dto.note;
    this.parentCompanyId = dto.parentCompanyId;
    this.email = dto.email;
  };
}

export interface CompanyAccountManagers {
  workers?: CompanyWorker[];
}

export interface CompanyContacts {
  workers?: CompanyWorker[];
}

export interface CompanyWorker {
  id?: number;
  companyId?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  mobilePhone?: string;
  occupationId?: number;
  occupationName?: string;
  fullName?: string;
  primary?: boolean;
  userId?: number;
  name?: string;
}

export interface CompanyCategory {
  id: number;
  parentId: number;
  name?: string;
  description?: string;
  code?: string;
}

export interface CityMap {
  cityDTO: AddressMapItem;
  countryDTO: AddressMapItem;
  stateDTO: AddressMapItem;
}

export interface CompanyAddress {
  addressTypeId?: AddressType | keyof typeof AddressType;
  id?: number;
  address?: string;
  apartment?: string;
  cityId?: number;
  entrance?: string;
  floor?: string;
  number?: string;
  postCode?: string;
  street?: string;
  map?: {
    cityDTO: AddressMapItem;
    countryDTO: AddressMapItem;
    stateDTO: AddressMapItem;
  };
}

export interface AddressMapItem {
  id: number;
  parentId?: number;
  name: string;
  code?: string;
  description?: string;
}

export enum AddressType {
  Secondary = 'Secondary',
  Primary = 'Primary',
}
